export default __webpack_public_path__ + "static/testimonial-photo-3-1287f47eabc81133b950d368a00d4b43.jpeg";